import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  holidayPromoSettingsRequest,
  holidayPromoSettingsSuccess,
  holidayPromoSettingsFailure,
} = createActions(
  'HOLIDAY_PROMO_SETTINGS_REQUEST',
  'HOLIDAY_PROMO_SETTINGS_SUCCESS',
  'HOLIDAY_PROMO_SETTINGS_FAILURE',
);

export function fetchHolidayPromoSetting(vendor = 'LHI') {
  return (dispatch) => {
    dispatch(holidayPromoSettingsRequest());
    return request(`holiday_promo_settings?vendor=${vendor}`)
      .then(({ json }) => dispatch(holidayPromoSettingsSuccess(json)))
      .catch(error => dispatch(holidayPromoSettingsFailure(error)));
  };
}

const {
  updateHolidayPromoSettingsRequest,
  updateHolidayPromoSettingsSuccess,
  updateHolidayPromoSettingsFailure,
} = createActions(
  'UPDATE_HOLIDAY_PROMO_SETTINGS_REQUEST',
  'UPDATE_HOLIDAY_PROMO_SETTINGS_SUCCESS',
  'UPDATE_HOLIDAY_PROMO_SETTINGS_FAILURE',
);

export function updateHolidayPromoSetting(attrs, vendor = 'LHI') {
  return (dispatch) => {
    dispatch(updateHolidayPromoSettingsRequest());
    return request(`holiday_promo_settings?vendor=${vendor}`, {
      method: 'PUT',
      body: { holiday_promo_setting: attrs },
    })
      .then(({ json }) => dispatch(updateHolidayPromoSettingsSuccess(json)))
      .catch((error) => {
        dispatch(updateHolidayPromoSettingsFailure(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/holiday_promo_settings.js